/* Copyright (c) 2021-2026, NVIDIA CORPORATION.  All rights reserved.
*
* NVIDIA CORPORATION and its licensors retain all intellectual property
* and proprietary rights in and to this software, related documentation
* and any modifications thereto.  Any use, reproduction, disclosure or
* distribution of this software and related documentation without an express
* license agreement from NVIDIA CORPORATION is strictly prohibited.
*/

/** This file was automatically generated. DO NOT MODIFY IT BY HAND. */

/* eslint-disable @typescript-eslint/naming-convention */

import { BridgeCommands } from '../../../src/bridge.commands';

import { Types } from '../../types/index';

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const EnablePerfStatsNotification: BridgeCommands.Command<
    Types.Share.Nvperfmon.EnablePerfStatsNotificationParameters,
    Types.Share.Nvperfmon.EnablePerfStatsNotificationReturn
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'NvPerfMon',
    method: 'EnablePerfStatsNotification',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const RegisterPerfStatsNotifications: BridgeCommands.Command<
    {},
    Types.Share.Nvperfmon.RegisterPerfStatsNotificationsReturn
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'NvPerfMon',
    method: 'RegisterPerfStatsNotifications',
    persistent: true
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const SetProcessId: BridgeCommands.Command<
    Types.Share.Nvperfmon.SetProcessIdParameters,
    any
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'NvPerfMon',
    method: 'SetProcessId',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const SetMetricSampleSize: BridgeCommands.Command<
    Types.Share.Nvperfmon.SetMetricSampleSizeParameters,
    any
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'NvPerfMon',
    method: 'SetMetricSampleSize',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const ResetAverageMetrics: BridgeCommands.Command<
    {},
    any
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'NvPerfMon',
    method: 'ResetAverageMetrics',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const GetDefaultLoggingPath: BridgeCommands.Command<
    {},
    Types.Share.Nvperfmon.GetDefaultLoggingPathReturn
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'NvPerfMon',
    method: 'GetDefaultLoggingPath',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const LoggingToggle: BridgeCommands.Command<
    Types.Share.Nvperfmon.LoggingToggleParameters,
    any
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'NvPerfMon',
    method: 'LoggingToggle',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const AlignLatencyMonitoringRectangle: BridgeCommands.Command<
    {},
    any
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'NvPerfMon',
    method: 'AlignLatencyMonitoringRectangle',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const GetRLAMonitorSupport: BridgeCommands.Command<
    {},
    Types.Share.Nvperfmon.GetRLAMonitorSupportReturn
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'NvPerfMon',
    method: 'GetRLAMonitorSupport',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const ShowFlashIndicator: BridgeCommands.Command<
    Types.Share.Nvperfmon.ShowFlashIndicatorParameters,
    any
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'NvPerfMon',
    method: 'ShowFlashIndicator',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const SetFlashIndicatorSize: BridgeCommands.Command<
    Types.Share.Nvperfmon.SetFlashIndicatorSizeParameters,
    any
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'NvPerfMon',
    method: 'SetFlashIndicatorSize',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const GetGpuInfo: BridgeCommands.Command<
    {},
    Types.Share.Nvperfmon.GetGpuInfoReturn
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'NvPerfMon',
    method: 'GetGpuInfo',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const powerStatusNotification: BridgeCommands.Command<
    {},
    Types.Share.Nvperfmon.powerStatusNotificationReturn
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'NvPerfMon',
    method: 'powerStatusNotification',
    persistent: true
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const CheckRLASupportedDriver: BridgeCommands.Command<
    {},
    Types.Share.Nvperfmon.CheckRLASupportedDriverReturn
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'NvPerfMon',
    method: 'CheckRLASupportedDriver',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const GetNGXOverrideState: BridgeCommands.Command<
    Types.Share.Nvperfmon.GetNGXOverrideStateParameters,
    Types.Share.Nvperfmon.GetNGXOverrideStateReturn
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'NvPerfMon',
    method: 'GetNGXOverrideState',
    persistent: false
};

export const Nvperfmon = {
EnablePerfStatsNotification,
RegisterPerfStatsNotifications,
SetProcessId,
SetMetricSampleSize,
ResetAverageMetrics,
GetDefaultLoggingPath,
LoggingToggle,
AlignLatencyMonitoringRectangle,
GetRLAMonitorSupport,
ShowFlashIndicator,
SetFlashIndicatorSize,
GetGpuInfo,
powerStatusNotification,
CheckRLASupportedDriver,
GetNGXOverrideState
};
